import React, { useState } from 'react'
import Layout from '../Layout/Layout'
import {Form} from 'react-bootstrap';
import axios from 'axios';
function RecoverPassword() {
    const [validated, setValidated] = useState(false);
    const[email, setEmail] = useState('');
    const [errMsg, setErrMsg] = useState({});
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [formHide, setFormHide] = useState('');
    const handleSubmit = async(event)=>{
        setErrMsg({});
        setLoading(true);
        try {
            //console.log(email)
            event.preventDefault();
            const form = event.currentTarget;
            //console.log(form)
            if (form.checkValidity() === false) {
              event.stopPropagation();
              setLoading(false);
            }    
            setValidated(true);
            if(form.checkValidity()===true) {
                const resetUrl = window.location.origin+'/resetpassword';
                let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/forgot-password`,{identity:email,resetUrl:resetUrl});
                //console.log(data)            
                if(data?.status){
                    //console.log(data?.message)
                    setErrMsg({cls:'alert alert-success text-center', msg:data?.message});
                    setEmail('')
                    setLoading(false);
                    setValidated(false)
                    setFormHide(' form-hide');
                    setSent(true)
                }else{
                    //console.log(data?.message)
                    setLoading(false);
                    setErrMsg({cls:'alert alert-danger text-center', msg:data?.message});
                    setFormHide('');
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
  return (    
    <Layout title="Forgot your password | Chaashni Couture">
        <div className="site-content-wrap login">
            <div className='loginbox'>
                <h2>Forgot your password?</h2>
                <div className='login-inner' style={{border:"none"}}>                    
                    <div className='login-content'> 
                        {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                        <Form noValidate validated={validated} onSubmit={handleSubmit} className={`reset-form${formHide}`}>            
                        <div className='login-data'>Please enter your email address. We will send you an email to help you create a new password.</div>                      
                            <div className='login-data'>
                                <input type="email" placeholder="Email Address" className='form-control input-text' value={email} required onChange={(e)=>{ setEmail(e.target.value) }}/>
                            </div>                        
                        <div className='login-data'><button type="submit" className="btn" style={{width:"205px"}} disabled={loading?true:false}>{loading?'Sending...':'Reset password'}</button></div> 
                        </Form> 
                        {sent?( <p style={{margin:"0"}}>A password reset email has been sent to the email address on file for your account, but may take several minutes to show up in your inbox. Please wait at least 10 minutes before attempting another reset.</p>):''}
                          
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}

export default RecoverPassword
